import React from 'react';

export type ViewMode = 'cards' | 'list';

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
  className?: string;
  /** Accessible label for the control */
  'aria-label'?: string;
}

/**
 * Toggle between Cards and List view for match listings.
 * Use in CMS, Reports, Replay, and Score app headers.
 */
const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  value,
  onChange,
  className = '',
  'aria-label': ariaLabel = 'View mode',
}) => (
  <div
    className={`inline-flex rounded-lg border border-gray-200 bg-gray-50 p-0.5 ${className}`}
    role="group"
    aria-label={ariaLabel}
  >
    <button
      type="button"
      onClick={() => onChange('cards')}
      className={`p-2 rounded-md transition-colors ${
        value === 'cards'
          ? 'bg-white text-blue-600 shadow-sm'
          : 'text-gray-500 hover:text-gray-700'
      }`}
      title="Cards view"
      aria-pressed={value === 'cards'}
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
      </svg>
    </button>
    <button
      type="button"
      onClick={() => onChange('list')}
      className={`p-2 rounded-md transition-colors ${
        value === 'list'
          ? 'bg-white text-blue-600 shadow-sm'
          : 'text-gray-500 hover:text-gray-700'
      }`}
      title="List view"
      aria-pressed={value === 'list'}
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
      </svg>
    </button>
  </div>
);

export default ViewModeToggle;
